"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalDialogKeys = void 0;
var GlobalDialogKeys;
(function (GlobalDialogKeys) {
    GlobalDialogKeys["DEFAULT"] = "default";
    //* BUTTONS *//
    GlobalDialogKeys["GRANT_ROLE"] = "grantRole";
    GlobalDialogKeys["ACCOUNT"] = "account";
    GlobalDialogKeys["ADDRESS"] = "address";
    GlobalDialogKeys["ALLOWANCE"] = "allowance";
    GlobalDialogKeys["ADD_ETH_LISTENER"] = "addEthListener";
    GlobalDialogKeys["ROYALTY"] = "royalty";
    GlobalDialogKeys["CONTRACT_MINT"] = "contractMint";
    GlobalDialogKeys["CONTRACT_ALLOWANCE"] = "contractAllowance";
    GlobalDialogKeys["TRANSFER"] = "transfer";
    GlobalDialogKeys["REMOVE_ETH_LISTENER"] = "removeEthListener";
    GlobalDialogKeys["SET_BASE_TOKEN_URI"] = "setBaseTokenUri";
    GlobalDialogKeys["SET_CHAIN_LINK_SUBSCRIPTION"] = "setChainLinkSubscription";
    GlobalDialogKeys["TEMPLATE_MINT"] = "templateMint";
    GlobalDialogKeys["COLLECTION_UPLOAD"] = "collectionUpload";
    GlobalDialogKeys["DISPENSER_UPLOAD"] = "dispenserUpload";
    GlobalDialogKeys["DISPENSER_ALLOWANCE"] = "dispenserAllowance";
    GlobalDialogKeys["TOP_UP"] = "topUp";
    GlobalDialogKeys["CLAIM_UPLOAD"] = "claimUpload";
    GlobalDialogKeys["STAKING_WITHDRAW_PENALTY"] = "stakingWithdrawPenalty";
    GlobalDialogKeys["STAKING_CHECK_BALANCE"] = "stakingCheckBalance";
    GlobalDialogKeys["CHAIN_LINK_ADD_CUSTOMER_DIALOG_KEY"] = "chainLinkAddCustomer";
    GlobalDialogKeys["CHAIN_LINK_FUND_SUBSCRIPTION_DIALOG_KEY"] = "chainLinkFundSubscription";
    //* FORMS *//
    GlobalDialogKeys["ERC_20_CONTRACT_CREATE"] = "erc20ContractCreate";
    GlobalDialogKeys["ERC_20_CONTRACT_EDIT"] = "erc20ContractEdit";
    GlobalDialogKeys["NATIVE_CONTRACT_CREATE"] = "nativeContractCreate";
    GlobalDialogKeys["NATIVE_CONTRACT_EDIT"] = "nativeContractEdit";
    GlobalDialogKeys["ERC721_CONTRACT_CREATE"] = "erc721ContractCreate";
    GlobalDialogKeys["ERC721_CONTRACT_EDIT"] = "erc721ContractEdit";
    GlobalDialogKeys["ERC721_TEMPLATE_CREATE"] = "erc721TemplateCreate";
    GlobalDialogKeys["ERC721_TEMPLATE_EDIT"] = "erc721TemplateEdit";
    GlobalDialogKeys["ERC721_TOKEN_VIEW"] = "erc721TokenView";
    GlobalDialogKeys["ERC998_CONTRACT_EDIT"] = "erc998ContractEdit";
    GlobalDialogKeys["ERC998_TEMPLATE_CREATE"] = "erc998TemplateCreate";
    GlobalDialogKeys["ERC998_TEMPLATE_EDIT"] = "erc998TemplateEdit";
    GlobalDialogKeys["ERC998_TOKEN_VIEW"] = "erc998TokenView";
    GlobalDialogKeys["ERC998_TOKEN_WITHDRAW"] = "erc998TokenWithdraw";
    GlobalDialogKeys["ERC998_COMPOSITION_CREATE"] = "erc998CompositionCreate";
    GlobalDialogKeys["ERC998_COMPOSITION_VIEW"] = "erc998CompositionView";
    GlobalDialogKeys["ERC1155_CONTRACT_CREATE"] = "erc1155ContractCreate";
    GlobalDialogKeys["ERC1155_CONTRACT_EDIT"] = "erc1155ContractEdit";
    GlobalDialogKeys["ERC1155_TEMPLATE_CREATE"] = "erc1155TemplateCreate";
    GlobalDialogKeys["ERC1155_TEMPLATE_EDIT"] = "erc1155TemplateEdit";
    GlobalDialogKeys["WAITLIST_CONTRACT_EDIT"] = "waitlistContractEdit";
    GlobalDialogKeys["WAITLIST_LIST_CREATE"] = "waitlistListCreate";
    GlobalDialogKeys["WAITLIST_LIST_EDIT"] = "waitlistListEdit";
    GlobalDialogKeys["WAITLIST_ITEM_CREATE"] = "waitlistItemCreate";
    GlobalDialogKeys["WAITLIST_LIST_CREATE_BUTTON"] = "waitlistListCreateButton";
    GlobalDialogKeys["WAITLIST_LIST_UPLOAD"] = "waitlistListUpload";
    GlobalDialogKeys["CLAIM_TEMPLATE_CREATE"] = "claimTemplateCreate";
    GlobalDialogKeys["CLAIM_TEMPLATE_EDIT"] = "claimTemplateEdit";
    GlobalDialogKeys["CLAIM_TOKEN_CREATE"] = "claimTokenCreate";
    GlobalDialogKeys["CLAIM_TOKEN_EDIT"] = "claimTokenEdit";
    GlobalDialogKeys["LOOT_BOX_MINT_DIALOG_KEY"] = "lootBoxMint";
    GlobalDialogKeys["DISCRETE_CREATE"] = "discreteCreate";
    GlobalDialogKeys["DISCRETE_EDIT"] = "discreteEdit";
    GlobalDialogKeys["BREED_LIMIT_DIALOG_KEY"] = "breedLimit";
    GlobalDialogKeys["STAKING_CONTRACT_EDIT"] = "stakingContractEdit";
    GlobalDialogKeys["STAKING_RULE_EDIT"] = "stakingRuleEdit";
    GlobalDialogKeys["STAKING_RULE_CREATE"] = "stakingRuleCreate";
    //* DEPLOY *//
    GlobalDialogKeys["ERC20_CONTRACT_DEPLOY"] = "ecr20ContractDeploy";
    GlobalDialogKeys["ERC721_CONTRACT_DEPLOY"] = "ecr721ContractDeploy";
    GlobalDialogKeys["ERC998_CONTRACT_DEPLOY"] = "ecr998ContractDeploy";
    GlobalDialogKeys["ERC1155_CONTRACT_DEPLOY"] = "ecr1155ContractDeploy";
    GlobalDialogKeys["COLLECTIONS_CONTRACT_DEPLOY"] = "collectionContractDeploy";
    GlobalDialogKeys["STAKING_CONTRACT_DEPLOY"] = "stakingContractDeploy";
    //* VIEW *//
})(GlobalDialogKeys || (exports.GlobalDialogKeys = GlobalDialogKeys = {}));
//# sourceMappingURL=index.js.map